import React, {useState, useEffect} from "react";
import ProjectAPIs from "../../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useNavigate, useParams } from "react-router-dom";
import { AiFillEdit } from "react-icons/ai";
import { MdCancel, MdEdit } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { Form } from "react-bootstrap";
import DropDown from "../../../../../../DropDown/DropDown";
import CompanyAPIs from "../../../../../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import ApiResponseHandler from "../../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../../Contexts/ToastContext";

export default function ViewProjectEngineer(){
    
    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [engineerData, setEngineerData] = useState({});

    const [engineerCompanyID, setEngineerCompanyID] = useState();
    const [engineerID, setEngineerID] = useState();
    const [contactedEng, setContactedEng] = useState();
    const [employees, setEmployees] = useState([]);
    // const [phone, setPhone] = useState()

    const getEngineerData = (projectID) => {
        ProjectAPIs.GetProjectEngineer(projectID)
        .then((response) => {
            if(response.status === 200){
                setEngineerData(response.data);
                setEngineerCompanyID(response.data.company?.id ?? '');
                setEngineerID(response.data.engineer_id ?? '');
                setContactedEng(response.data.contacted_engineer ?? '');
                // setPhone(response.data.phone);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err)
            ApiResponseHandler(err.response, navigate);
        })
    }

    const editProjectEngineer = (e) => {

        e.preventDefault();
        e.stopPropagation();

        setSending(true);
        const putJSON = {
            engineering_company_id: engineerCompanyID === '' ? null :  parseInt(engineerCompanyID),
            engineer_id: engineerID === '' ? null :parseInt(engineerID),
            contacted_engineer: contactedEng,
            // phone: phone
        }
        ProjectAPIs.PutProjectEngineer(params.ProjectID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getEngineerData(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Engineer details updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })


    }

    const getEmployees = () => {
        CompanyAPIs.GetCompanyEmployees(engineerData.company.id)
        .then((response) => {
            setEmployees(response.data);
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    const handleCancel = () => {
        setEngineerID(engineerData.engineer_id ?? '')
        setEngineerCompanyID(engineerData.company?.id ?? '');
        setEditing(false);
    }

    const handleChangeCompany = (e) => {
        setEngineerCompanyID(e.target.value);
        setEngineerID('');
    }

    useEffect(() => {
        getEngineerData(params.ProjectID);
    }, [params.ProjectID])

    useEffect(() => {
        if(engineerData.company){
            getEmployees();
        }
    }, [engineerData, params.projectID])
    
    if(loading){
        return(
            <div>Loading...</div>
        )
    }
    return(
        <div className="project-section">
                <Form onSubmit={editProjectEngineer}>
                    <div className="project-seciton-header">
                        <h5 >Engineering</h5>
                        <div className="project-header-actions m-1">
                            <button
                                disabled={sending || !editing}
                                type="submit"
                                className="save-btn"
                                style={editing ? {display: 'block'} : {display: 'none'}}
                            >
                                {sending ? 'Saving...' : 'Save'}
                            </button>

                            {editing ? (
                                <button
                                    disabled={sending}
                                    type="button"
                                    className="cancel-btn"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                            ) : (
                                <button
                                    disabled={sending}
                                    type="button"
                                    className="edit-btn"
                                    onClick={() => setEditing(true)}
                                >
                                    <MdEdit /> Edit
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="project-section-body">

                        {editing?
                            <div className="project-section-body-item">
                                <DropDown.AllCompanies disabled={sending} className='editable-field' value={engineerCompanyID} onChange={handleChangeCompany} />
                            </div>
                            : 
                            <div className="project-section-body-item">
                                <h5>{engineerData?.company?.name ?? ''}</h5>
                            </div>
                        }
                        {editing ? (
                            <span 
                                className={`status-badge editable ${contactedEng ? 'complete' : 'active'}`}
                                onClick={() => setContactedEng(!contactedEng)}
                            >
                                {contactedEng ? "Contacted ✓" : "Not Contacted"}
                            </span>
                            ) : (
                            <span className={`status-badge ${engineerData.contacted_engineer ? 'complete' : 'active'}`}>
                                {engineerData.contacted_engineer ? "Contacted ✓" : "Not Contacted"}
                            </span>
                        )}

                        {editing ? 
                            <div className="project-section-body-item">
                                <span className="label">Engineer</span>
                                <DropDown.CompanyEmployees 
                                    companyID={engineerCompanyID} 
                                    value={engineerID}
                                    onChange={(e) => setEngineerID(e.target.value)}
                                    disabled={!editing || sending}
                                    size='sm'
                                    className='editable-field'
                                />
                            </div>

                            :
                            <div className="project-section-body-item">
                                <span className="label">Engineer</span>
                                {employees.find((e) => e.id === engineerData.engineer_id)?.first_name ?? ''} {employees.find((e) => e.id === engineerData.engineer_id)?.last_name ?? ''} 
                            </div>
                            
                        }

                        <div className="project-section-body-item">
                            <span className="label">Phone</span>
                            {engineerData.phone}
                        </div>
                        <div className="project-section-body-item">
                            <span className="label">Email</span>
                            {engineerData.email}
                        </div>

                            
                    </div>
                
            
                </Form>
            </div>
    )
    
}